import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PlanStatus } from '../interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/idp/base';

interface PlanStatusPayload {
  id: string;
  status: PlanStatus.InProgress | PlanStatus.Closed;
}

export const usePlanStatuses = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, status }: PlanStatusPayload) =>
      await falconClient.post(`${baseUrl}/plans/${id}/plan_statuses`, {
        status,
      }),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [clientKeys.usePlansIndex],
      });
    },
  });
};
